module.exports = __webpack_public_path__ + "img/upgrade.843eb562.svg";